// El bono de bienvenida, derivado del bloque `welcomeBonus` del resumen 360. Hay DOS estados: el
// del BLOQUE dice si el asiento se pudo leer, y el del ASIENTO si el dinero se movió.
import type {
    Customer360WelcomeBonus,
    WelcomeBonusEntry,
} from '@/api/services/retail-customer/retail-customer.client';

/** Los cinco desenlaces de la LECTURA. `absent` y `no-source` son hechos; los otros dos, huecos. */
export type WelcomeBonusRead =
    | { state: 'unread' }
    | { state: 'absent' }
    | { state: 'no-source' }
    | { state: 'unavailable' }
    | { state: 'entry'; entry: WelcomeBonusEntry };

/**
 * El bloque del bono leído. Un bloque que se dice leído y llega sin asiento se trata como ilegible:
 * afirmar «no cobró» con un contrato roto es la conclusión opuesta a la verdadera.
 */
export function welcomeBonusReadOf(block: Customer360WelcomeBonus | undefined): WelcomeBonusRead {
    if (!block) return { state: 'unread' };
    if (block.bonus) return { state: 'entry', entry: block.bonus };
    if (block.status === 'ABSENT') return { state: 'absent' };
    if (block.status === 'NO_SOURCE') return { state: 'no-source' };
    return { state: 'unavailable' };
}
